import type { SegmentSheetData } from "@/shared/store/segmentSheetStore"

export function segmentSheetHasCta(data: SegmentSheetData): boolean {
  return Boolean(data.button_text.trim() && data.button_url.trim())
}

export function segmentSheetAnalyticsParams(data: SegmentSheetData): {
  segment_id: string
  has_cta: boolean
  campaign_id?: string
} {
  return {
    segment_id: data.segment,
    has_cta: segmentSheetHasCta(data),
    ...(data.campaignId ? { campaign_id: data.campaignId } : {}),
  }
}
